define([
    'text!product-detail/component/feature-item2.html',
    'product-detail/component/images-box',
    'common/utils'
], function(
    tpl,
    ImagesBox,
    Utils
){
    return {
        template: tpl,
        components: {
            ImagesBox: ImagesBox
        },
        props: {
            item: {
                type: Object
            },
            index: {
                type: String
            }
        },

        watch: {
            item: function(newValue)
            {
                console.log(this.item.images);

                if(this.item.images.length>0)
                {
                    console.log(this.item.images);

                    this.$set(this.item, 'images', this.item.images);
                }
            }
        },
        methods: {
            ln2br: Utils.ln2br
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/component/feature-item2.js
// module id = 269
// module chunks = 0